import { useMemo, useState } from 'react'

import type { Affiliate } from 'services/affiliates/types'
import * as affiliatesApi from 'services/affiliates'
import SidebarList from 'ui-component-library/components/DailyList/SidebarList'
import AffiliateItem from 'ui-component-library/components/DailyList/AffiliateItem'
import { useSelector } from 'react-redux'
import { getUserLatLng } from 'store/user/selectors'
import useLoadableList from '../useLoadableList'

const PER_PAGE = 10

type Props = {
  nearMeText: string
  allText: string
  headlineText: string
}

function DailyAffiliateListContainer({
  nearMeText,
  allText,
  headlineText,
}: Props) {
  const latLng = useSelector(getUserLatLng)
  const [selectedFilter, setSelectedFilter] = useState('all')

  const fetchResults = useMemo(() => {
    const params: {
      perPage: number
      near?: string
    } = {
      perPage: PER_PAGE,
      near: undefined,
    }

    if (selectedFilter === 'nearMe') {
      params.near = latLng
    }

    return (page: number) =>
      affiliatesApi.fetchAffiliates({
        ...params,
        page,
      })
  }, [selectedFilter, latLng])

  const { isLoading, results, onLoadMore } = useLoadableList<Affiliate>(
    fetchResults,
  )

  const filterOptions = [
    { value: 'all', label: allText },
    { value: 'nearMe', label: nearMeText },
  ]

  function handleChangeFilter(value: string) {
    setSelectedFilter(value)
  }

  return (
    <SidebarList
      isLoading={isLoading}
      filterOptions={filterOptions}
      selectedFilter={selectedFilter}
      onChangeFilter={handleChangeFilter}
      onLoadMore={onLoadMore}
      headlineText={headlineText}
    >
      {results.map((result) => (
        <AffiliateItem key={result.name} result={result} />
      ))}
    </SidebarList>
  )
}

export default DailyAffiliateListContainer
